import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.setPrefix()
  }

  async setPrefix() {
    try {
      const response = await fetch("https://ipapi.co/json")
      const data = await response.json()
      const callingCode = data.country_calling_code || ""

      if (this.inputTarget && callingCode && !this.inputTarget.value.startsWith("+")) {
        this.inputTarget.value = `${callingCode} `
      }
    } catch (error) {
      console.error("Failed to fetch country calling code", error)
    }
  }
}
